export enum SingleSpaAppStatus {
	MOUNTED = "MOUNTED",
	NOT_MOUNTED = "NOT_MOUNTED",
}

export interface SingleSpaPopStateEvent extends PopStateEvent {
	singleSpa?: boolean;
	singleSpaTrigger?: string; // pushState | replaceState
}

export interface SingleSpaEventDetail {
	originalEvent: SingleSpaPopStateEvent;
	newAppStatuses: { [key: string]: SingleSpaAppStatus.MOUNTED | SingleSpaAppStatus.NOT_MOUNTED };
	appsByNewStatus: { [SingleSpaAppStatus.MOUNTED]: Array<string>; [SingleSpaAppStatus.NOT_MOUNTED]: Array<string> };
	totalAppChanges: number;
	oldUrl: string;
	newUrl: string;
	navigationIsCanceled: boolean;
	cancelNavigation: () => void;
}

export interface SingleSpaEvent extends Event {
	detail: SingleSpaEventDetail;
}

export type AppNames = "mf-cart" | "mf-productlist" | "mf-wishlist";
